import Route from '@ember/routing/route';
import { type Registry as Services, service } from '@ember/service';
import type { Market } from 'frontend-utils/models';
import type { HotelAndMarketServiceWithMarket } from 'lumen/services/hotel-and-market';
import type { Transition } from 'lumen/services/transition';
import protectedRoute from 'lumen/utils/decorators/protected-route';
import { resetIdQueryParams } from 'lumen/utils/spider';

@protectedRoute({ features: ['spider.market.heatmap'] })
export default class MarketHeatmapRoute extends Route {
  queryParams = {
    view: {},
  };

  @service('hotel-and-market')
  declare hotelAndMarketService: HotelAndMarketServiceWithMarket;
  @service declare router: Services['router'];

  lastMarketId: string | null = null;

  beforeModel(transition: Transition): void {
    if (
      this.lastMarketId !== this.hotelAndMarketService.market.id &&
      transition.from
    ) {
      const queryParams = resetIdQueryParams(transition);

      transition.abort();
      this.router.transitionTo(
        'market.heatmap',
        this.hotelAndMarketService.market.id,
        {
          queryParams,
        },
      );
    }

    this.lastMarketId = this.hotelAndMarketService.market.id;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  model() {
    return this.modelFor('market') as Market;
  }
}
